<script setup lang="ts">
import TutorialFrame from '@/components/Interface/Modal/Modals/Tutorial/TutorialFrame.vue'
import ActionButton from '@/components/Elements/Buttons/ActionButton.vue'
import { usePlayerFlagsStore } from '@/stores/playerFlagsStore'
import GenericIcon from '@/components/Elements/Images/Icons/GenericIcon.vue'
import Alert from '@/components/Elements/Alerts/Alert.vue'

const playerFlagsStore = usePlayerFlagsStore()

async function completeTutorial() {
  // Mark the tutorial as complete and permanently hide it
  await playerFlagsStore.setFlag('tutorial_last_words', 'true')
  await playerFlagsStore.setFlag('tutorial_current_step', 'tutorial_last_words')
  await playerFlagsStore.setFlag('tutorial_complete', 'true')
}
</script>

<template>
  <TutorialFrame
    video-url="https://cdn.ferion.com/videos/advisors/temperate/news.webm"
  >
    <template #text>
      <p class="pb-2">
        Thank you for your time, You are all set to lead our empire into the future!
      </p>
      <p class="pb-2">
        We might check in again if something important comes up.
      </p>
    </template>

    <template #alerts>
    </template>

    <template #buttons>
      <ActionButton @click="completeTutorial">
        Thank you!
      </ActionButton>
    </template>
  </TutorialFrame>
</template>

<style scoped lang="scss">
</style>